<div class="step-bar-container">
  <div style="overflow-x: auto; width: 100%">
    <div class="card" style="padding: 15px 10px; min-width: 768px">
      <div class="p-steps">
        <ul role="tablist">
          <li *ngFor="let step of steps; let i = index">
            <a [ngClass]="{'active': isStepSelected(step)}" (click)="onStepClick(step)">
              <span class="p-steps-number" 
                    [style.background-color]="isStepSelected(step) ? 'var(--primary-color)' : step?.stageColor"
                    [style.color]="isStepSelected(step) ? '#fff' : step?.color">
                {{step?.count}}
              </span>
              <span class="p-steps-title overview-box-name" 
                    [style.font-weight]="isStepSelected(step) ? 'bold' : 'normal'">
                {{step?.name}}
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div> 